import React from "react";


class JPSubmission extends React.Component{
    render(){
return(
    <div className="JP">
        <h3>轴音旋律-AnXiens- 2025 オリジナル楽曲公募活動本日より開催開始！</h3>
        <p>活動ルール：</p><p>
- 投稿する楽曲の完全な著作権を有していること。
</p><p>
- 楽曲の長さは1分50秒～2分20秒に制限。
</p><p>
- 投稿は締切前に未公開のオリジナル楽曲のみ受付。
</p><p>
- 歌詞と歌唱が含まれても構いませんが、歌詞は審査および倫理基準に合致する必要があります。歌詞がある場合、投稿時に歌詞の原文を必ずご提供ください。
</p><p>
- 参加者は1人につき最大3曲まで投稿可能。チーム名義で参加する場合、メンバー名義と個人名義は共用となります。
</p><p>
- 参加者は18歳以上である必要があります。18歳未満の作者は法定代理人による署名が必要です（投稿日時を基準）。
</p><br/><p>
投稿楽曲の取り扱いについて：
</p><p>
- 投稿後、7営業日以内に確認メールをお送りします。
</p><p>
- 投稿されたすべての楽曲は、今回の公募活動のみで使用され、GLACIA STUDIOにより厳重に管理されます。
</p><p>
- 提出されたすべての作品は審査され、その中からゲーム内で使用される楽曲を選定する場合があります。選定される楽曲の数はGLACIA STUDIOの判断で決定されます。
</p><p>
- 選ばれなかった楽曲は、いかなる形でも使用・公開されません。
</p><p>
- 選ばれた楽曲については、審査終了前にこちらからご連絡いたします。審査終了前に楽曲を公開することはできません。
</p><p>
- 審査終了前に連絡がなかった場合、その後自由に楽曲を公開することができます。
</p><br/><p>

著作権と契約について：
</p><p>
- 投稿後、楽曲の著作権は依然として投稿者に帰属しますが、当社と契約を結ぶまで保持されます。
</p><p>
- 楽曲が選ばれた場合、契約を結び、使用料を支払って楽曲の所有権を購入します。
</p><p>
- 提供された個人情報は厳重に管理され、契約および楽曲審査以外には使用されません。
</p><p>
投稿締切日： 2025/7/1  
審査締切日： 2025/7/30
</p><br/><p>
投稿に必要なファイルとフォーマット：
</p><p>
1. 参加者の本名とメールアドレス。
</p><p>
2. ゲーム内に表示される作曲家名またはバンド名。チーム名義で参加する場合、メンバー全員の名前を記載してください。
</p><p>
3. 楽曲名。
</p><p>
4. 楽曲のジャンル。
</p><p>
5. 楽曲のBPM。BPMが変動する場合は、ミリ秒または拍数で変速ポイントを記載してください。
</p><p>
6. 楽曲の紹介。歌詞がある場合、ここに歌詞も添付してください。
</p><p>
7. 楽曲ファイル。ファイル名は「2025AXSubmission_[SongTitle].wav」とし、フォーマットは48kHz、24Bitでお願いします。
</p><br/><p>
GLACIA STUDIOは本活動に関する最終的な解釈権を有します。  
ご質問がある場合は、以下のメールアドレスまでご連絡ください：  <a href="https://www.anxiens.com/event/songsubmission2025/">glacia_studio@foxmail.com</a>
</p><br/><br/>
    </div>    
    )
    }
    }

export default JPSubmission